import React from "react";
import BlueprintDashboard from "./BlueprintDashboard";

const dashboardModuleRoleIds = [
  "trustee",
  "principal",
  "superadmin",
  "Register",
  "accountant",
  "hr",
  "exam",
  "teacher",
  "student",
  "parent",
  "tp",
];

const staffModuleRoleIds = [
  "trustee",
  "principal",
  "superadmin",
  "Register",
  "accountant",
  "hr",
  "exam",
  "teacher",
];

export function DashboardModuleDashboard() {
  return (
    <BlueprintDashboard
      selectedRoleIds={dashboardModuleRoleIds}
      titleText="Dashboard Module"
      helperText="Leadership, campus operations, student, parent and placement dashboards."
      pillText="Dashboard module · role views"
    />
  );
}

export function StaffRoleDashboard() {
  return (
    <BlueprintDashboard
      selectedRoleIds={staffModuleRoleIds}
      titleText="Staff Dashboard Module"
      helperText="Leadership, operations and staff-facing dashboards for staff access."
      pillText="Staff module · role views"
    />
  );
}

export function TrusteeDashboardPage() {
  return (
    <BlueprintDashboard
      selectedRoleIds={["trustee"]}
      titleText="Trustee Dashboard"
      helperText="Cross-campus visibility for governing leadership."
      pillText="Trustee module · dashboard"
    />
  );
}

export function PrincipalDashboardPage() {
  return (
    <BlueprintDashboard
      selectedRoleIds={["principal"]}
      titleText="Principal Dashboard"
      helperText="Daily operating view for the campus head."
      pillText="Principal module · dashboard"
    />
  );
}

export function SuperAdminDashboardPage() {
  return (
    <BlueprintDashboard
      selectedRoleIds={["superadmin"]}
      titleText="Super Admin Dashboard"
      helperText="Platform-wide configuration, roles and permissions."
      pillText="Super Admin module · dashboard"
    />
  );
}

export function RegisterDashboardPage() {
  return (
    <BlueprintDashboard
      selectedRoleIds={["Register"]}
      titleText="Register Dashboard"
      helperText="Enquiries, applications and enrolment tracking."
      pillText="Register module · dashboard"
    />
  );
}

export function AccountantDashboardPage() {
  return (
    <BlueprintDashboard
      selectedRoleIds={["accountant"]}
      titleText="Accountant Dashboard"
      helperText="Fee collection, expenses and day book overview."
      pillText="Accountant module · dashboard"
    />
  );
}

export function HrDashboardPage() {
  return (
    <BlueprintDashboard
      selectedRoleIds={["hr"]}
      titleText="HR Dashboard"
      helperText="Staff records, attendance and onboarding."
      pillText="HR module · dashboard"
    />
  );
}

export function ExamDashboardPage() {
  return (
    <BlueprintDashboard
      selectedRoleIds={["exam"]}
      titleText="Examination Dashboard"
      helperText="Scheduling, evaluation and results publication."
      pillText="Exam module · dashboard"
    />
  );
}

export function TeacherDashboardPage() {
  return (
    <BlueprintDashboard
      selectedRoleIds={["teacher"]}
      titleText="Teacher Dashboard"
      helperText="Timetable, lesson plans and mentee follow-ups."
      pillText="Teacher module · dashboard"
    />
  );
}

export function StudentDashboardPage() {
  return (
    <BlueprintDashboard
      selectedRoleIds={["student"]}
      titleText="Student Dashboard"
      helperText="Attendance, fees, results and updates."
      pillText="Student module · dashboard"
    />
  );
}

export function ParentDashboardPage() {
  return (
    <BlueprintDashboard
      selectedRoleIds={["parent"]}
      titleText="Parent Dashboard"
      helperText="Attendance, fees and academic updates for your ward."
      pillText="Parent module · dashboard"
    />
  );
}

export function TpDashboardPage() {
  return (
    <BlueprintDashboard
      selectedRoleIds={["tp"]}
      titleText="Training & Placement Dashboard"
      helperText="Company visits, drive status and placement tracking."
      pillText="Training & Placement module · dashboard"
    />
  );
}

export function LibraryDashboardPage() {
  return (
    <BlueprintDashboard
      selectedRoleIds={["librarian"]}
      titleText="Library Dashboard"
      helperText="Catalogue health, member activity and circulation insights for the library."
      pillText="Library module · dashboard"
    />
  );
}

export function HostelDashboardPage() {
  return (
    <BlueprintDashboard
      selectedRoleIds={["hostel"]}
      titleText="Hostel Dashboard"
      helperText="Occupancy, residential billing and maintenance visibility for hostel operations."
      pillText="Hostel module · dashboard"
    />
  );
}

export function TransportDashboardPage() {
  return (
    <BlueprintDashboard
      selectedRoleIds={["transport"]}
      titleText="Transport Dashboard"
      helperText="Route occupancy, bus utilisation and transport fee status."
      pillText="Transport module · dashboard"
    />
  );
}

export default DashboardModuleDashboard;
